module.exports = __webpack_public_path__ + "4dd2c11de30aca438992465f50103271.png";